
import React, { useState, useEffect } from 'react';
import Logo from '../assets/Nandanam_logo.png';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <a className="navbar-brand" href="/">
          <img src={Logo} alt="Logo" height="40" />
        </a>

        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </div>

        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><a className="nav-link" href="/home">HOME</a></li>
          <li><a className="nav-link" href="/about">ABOUT</a></li>
         <li className={`dropdown ${dropdownOpen ? 'open' : ''}`}>
  <a
    href="#!"
    onClick={(e) => {
      e.preventDefault();
      setDropdownOpen(!dropdownOpen);
    }}
  >
    AMENITIES ▾
  </a>
  <ul className="dropdown-menu-col-1">
    <li><a href="/baby-shoot">Baby Studio</a></li>
    <li><a href="/pre-wedding">Pre-wedding Studio</a></li>
    <li><a href="/function-hall">Open Function Hall</a></li>
    <li><a href="/hotel-rooms">Hotel Rooms</a></li>
    <li><a href="/pool-overview">Swimming Pool</a></li>
    <li><a href="/restaurant-overview">Resturant</a></li>
  </ul>
</li>
<li><a className="nav-link" href="/resorts">RESORT</a></li>
          <li><a className="nav-link" href="/ventures">VENTURE</a></li>
          <li><a className="nav-link" href="/gallery">GALLERY</a></li>
          <li><a className="nav-link" href="/contact">CONTACT</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
